import { render, staticRenderFns } from "./goodsCollection.vue?vue&type=template&id=1c2f609f&scoped=true&"
import script from "./goodsCollection.vue?vue&type=script&lang=js&"
export * from "./goodsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f609f",
  null
  
)

export default component.exports